(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	var roles = ['Administrators', 'Billing Administrator', 'Billing User'];
        $stateProvider.state('billing-reports', {
            abstract: true,
            parent: 'app'
        }).state('billing-reports-main', {
            abstract: true,
            parent: 'billing-reports',
            url: '/billing-reports-main',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nonnctc.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/billing-reports/billing-reports.html',
                    controller: 'BillingReportsMainController',
                    controllerAs: 'vm'
                }
            }
        }).state('billing-reports-main.nonnctc', {
            url:         '/nonnctc',
            templateUrl: 'app/billing-reports/nonnctc/nonnctc.html',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nonnctc.home.title'
            },
            controller: 'NonNctcController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('nonnctc');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('billing-reports-main.nctc', {
            url:         '/nctc',
            templateUrl: 'app/billing-reports/nctc/nctc.html',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nctc.home.title'
            },
            controller: 'NctcController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('nctc');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('billing-reports-main.dta', {
            url:         '/dta',
            templateUrl: 'app/billing-reports/dta/dta.html',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.dta.home.title'
            },
            controller: 'DtaController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('dta');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('billing-reports-main.revenue', {
            url:          '/revenue',
            templateUrl: 'app/billing-reports/revenue/revenue.html',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.revenue.home.title'
            },
            controller: 'RevenueController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                     $translatePartialLoader.addPart('revenue');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });

    }
})();
